/** @format */

import React, { useContext } from "react";
import { FaChevronLeft} from "react-icons/fa";
import Loading from "../../../../../components/Loading/Loading";
import {
  handleUpdateLoading,
} from "../../../../../state/EditServiceReducer/EditServiceActionCreator";
import { EDIT_SERVICE_CONTEXT } from "../EditService";
import CommonButton from "../../../../../components/CommonButton/CommonButton";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { AuthContext } from "../../../../../Contexts/UserContext/UserContext";
import EditServiceThumb from "./EditServiceThumb";
import EditServiceGallery from "./EditServiceGallery";



const EditServiceImage = () => {
  const { state, editDispatch } = useContext(EDIT_SERVICE_CONTEXT);
  const serviceId = localStorage.getItem("ServiceId");

  const navigate = useNavigate();
  const { logOut } = useContext(AuthContext);

  const {
    loading,
    error,
    errorMessage,
    newGallery,
    updateService,
    updateLoading,
  } = state;

  if (loading) {
    return <Loading>Loading...</Loading>;
  }
  if (error) {
    return (
      <p className="text-center my-52 text-2xl tracking-widest text-error font-semibold ">
        {errorMessage}
      </p>
    );
  }

  /* ======================Submit updated service to the db ============================= */
  const handleUpdateService = () => {
    editDispatch(handleUpdateLoading(true));
    delete updateService._id;
    updateService.gallery = newGallery;

    fetch(
      `${process.env.REACT_APP_SERVER_URL}/admin/service/${serviceId}/update`,
      {
        method: "PUT",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${localStorage.getItem("AccessToken")}`,
        },
        body: JSON.stringify(updateService),
      }
    )
      .then((res) => {
        if (res.status === 401 || res.status === 403) {
          return logOut();
        }
        return res.json();
      })
      .then((data) => {
        if (data.acknowledged) {
          editDispatch(handleUpdateLoading(false));
          toast.success("Your service has been modified successfully");
          navigate(`/service/${serviceId}`);
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <section>
      {updateLoading ? (
        <Loading>Updating your service. Please wait..</Loading>
      ) : (
        <div>
          {/* =============================== Thumbnail ============================== */}

          <EditServiceThumb></EditServiceThumb>

          {/* ==================================== Gallery ============================ */}

          <EditServiceGallery></EditServiceGallery>

          <div className="flex justify-between items-center mt-10">
            <Link to={`/dashboard/services/${serviceId}`}>
              <CommonButton type={"button"} customClass={"tracking-[3px]"}>
                <FaChevronLeft className="mr-3" />
                Previous
              </CommonButton>
            </Link>
            <CommonButton
              type={"submit"}
              clickFunction={handleUpdateService}
              customClass={"tracking-[3px]"}
            >
              Update Service
            </CommonButton>
          </div>
        </div>
      )}
    </section>
  );
};

export default EditServiceImage;
